(() => {
  if (window.BikiniYesShippingCalculatorLoaded) return;
  window.BikiniYesShippingCalculatorLoaded = true;

  const allowedCountries = new Set([
    'Albania',
    'American Samoa',
    'Australia',
    'Austria',
    'Belgium',
    'Brazil',
    'Bulgaria',
    'Canada',
    'Croatia',
    'Cyprus',
    'Czech Republic',
    'Czechia',
    'Denmark',
    'Estonia',
    'Finland',
    'France',
    'Germany',
    'Greece',
    'Guam',
    'Hungary',
    'Ireland',
    'Israel',
    'Italy',
    'Japan',
    'Latvia',
    'Lithuania',
    'Luxembourg',
    'Malta',
    'Mexico',
    'Morocco',
    'Netherlands',
    'New Zealand',
    'Nigeria',
    'Poland',
    'Portugal',
    'Puerto Rico',
    'Qatar',
    'Romania',
    'Saudi Arabia',
    'Singapore',
    'Slovakia',
    'Slovenia',
    'South Africa',
    'Spain',
    'Sweden',
    'United Arab Emirates',
    'United Kingdom',
    'United States',
    'U.S. Virgin Islands',
    'US Virgin Islands',
    'United States Virgin Islands'
  ]);

  const getRoot = (target) => target && target.closest('[data-by-shipping-calculator]');

  const setResult = (root, message, isError = false) => {
    const results = root.querySelector('[data-by-shipping-results]');
    if (!results) return;
    results.innerHTML = '';
    const line = document.createElement('p');
    line.className = 'by-shipping-results__message';
    if (isError) line.setAttribute('role', 'alert');
    line.textContent = message;
    results.appendChild(line);
  };

  const setBusy = (root, busy) => {
    const button = root.querySelector('[data-by-shipping-calculate]');
    const idle = root.querySelector('[data-by-shipping-idle]');
    const loading = root.querySelector('[data-by-shipping-busy]');
    if (button) {
      button.disabled = busy;
      button.setAttribute('aria-busy', busy ? 'true' : 'false');
    }
    if (idle) idle.hidden = busy;
    if (loading) loading.hidden = !busy;
  };

  const loadCountries = (root) => {
    if (root.dataset.byCountriesLoaded === 'true') return Promise.resolve();
    if (root._byCountriesPromise) return root._byCountriesPromise;

    root._byCountriesPromise = (async () => {
      const country = root.querySelector('[data-by-shipping-country]');
      const province = root.querySelector('[data-by-shipping-province]');
      const provinceWrap = root.querySelector('[data-by-shipping-province-wrap]');
      if (!country || !province || !provinceWrap) throw new Error('Shipping fields unavailable');

      let source;
      if (typeof fetchSection === 'function') {
        const section = await fetchSection('country-options', {
          url: (window.MinimogSettings && window.MinimogSettings.base_url) || window.location.href
        });
        source = section && section.querySelector('#AddressCountry');
      } else {
        const sectionUrl = new URL(window.location.href);
        sectionUrl.searchParams.set('section_id', 'country-options');
        const response = await fetch(sectionUrl.toString(), { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Unable to load countries');
        const html = await response.text();
        source = new DOMParser().parseFromString(html, 'text/html').querySelector('#AddressCountry');
      }

      if (!source) throw new Error('Country options unavailable');

      const preferred = country.dataset.default || source.dataset.default || '';
      country.innerHTML = source.innerHTML;

      Array.from(country.options).forEach((option) => {
        const value = option.value.trim();
        const label = option.textContent.trim();
        if (!allowedCountries.has(value) && !allowedCountries.has(label)) option.remove();
      });

      country.disabled = false;
      province.disabled = false;

      const options = Array.from(country.options);
      const preferredOption = options.find((option) => {
        return option.value === preferred || option.textContent.trim() === preferred;
      });
      const fallbackOption = options.find((option) => {
        return option.value === 'Canada' || option.textContent.trim() === 'Canada';
      }) || options.find((option) => {
        return option.value === 'United States' || option.textContent.trim() === 'United States';
      }) || options[0];
      const selectedOption = preferredOption || fallbackOption;
      if (selectedOption) selectedOption.selected = true;
      country.dataset.default = selectedOption ? selectedOption.value : '';

      if (window.Shopify && window.Shopify.CountryProvinceSelector) {
        new window.Shopify.CountryProvinceSelector(country.id, province.id, {
          hideElement: provinceWrap.id
        });
      } else {
        const syncProvinces = () => {
          const option = country.options[country.selectedIndex];
          let provinces = [];
          try {
            provinces = JSON.parse((option && option.dataset.provinces) || '[]');
          } catch (_error) {}
          province.innerHTML = '';
          provinces.forEach((entry) => {
            const item = document.createElement('option');
            item.value = entry[0];
            item.textContent = entry[1];
            province.appendChild(item);
          });
          provinceWrap.hidden = provinces.length === 0;
        };
        country.addEventListener('change', syncProvinces);
        syncProvinces();
      }

      root.dataset.byCountriesLoaded = 'true';
    })();

    return root._byCountriesPromise;
  };

  const closeDialog = (root) => {
    const dialog = root && root.querySelector('[data-by-shipping-dialog]');
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
    if (!document.querySelector('[data-by-shipping-dialog][open]')) {
      document.documentElement.classList.remove('by-shipping-modal-open');
    }
  };

  const openDialog = (root) => {
    const dialog = root.querySelector('[data-by-shipping-dialog]');
    if (!dialog) return;

    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    document.documentElement.classList.add('by-shipping-modal-open');

    if (!dialog.dataset.byDialogReady) {
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog(root);
      });
      dialog.addEventListener('close', () => {
        if (!document.querySelector('[data-by-shipping-dialog][open]')) {
          document.documentElement.classList.remove('by-shipping-modal-open');
        }
      });
      dialog.dataset.byDialogReady = 'true';
    }

    loadCountries(root).catch(() => {
      setResult(root, root.dataset.unavailableMessage || 'Shipping rates could not be loaded.', true);
    });
  };

  const showRates = (root, rates) => {
    const results = root.querySelector('[data-by-shipping-results]');
    if (!results) return;
    results.innerHTML = '';

    if (!rates.length) {
      const message = root.dataset.cartEmpty === 'true'
        ? root.dataset.emptyCartMessage
        : ((window.MinimogStrings && window.MinimogStrings.noShippingRate) || root.dataset.unavailableMessage);
      setResult(root, message || 'No shipping rates were found.');
      return;
    }

    const heading = document.createElement('p');
    heading.className = 'by-shipping-results__heading';
    heading.textContent = (root.dataset.resultsLabel || 'Available shipping rates ([count])').replace('[count]', String(rates.length));
    results.appendChild(heading);

    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || root.dataset.currency || '';
    rates.forEach((rate) => {
      const row = document.createElement('p');
      row.className = 'by-shipping-results__rate';

      const name = document.createElement('span');
      name.textContent = rate.name || 'Shipping';

      const price = document.createElement('strong');
      const numericPrice = Number(rate.price);
      price.textContent = Number.isFinite(numericPrice) && numericPrice === 0
        ? (root.dataset.freeLabel || 'FREE')
        : String(rate.price || '') + (currency ? ' ' + currency : '');

      row.appendChild(name);
      row.appendChild(price);
      results.appendChild(row);
    });
  };

  const calculateRates = async (root) => {
    setBusy(root, true);
    try {
      await loadCountries(root);
      const country = root.querySelector('[data-by-shipping-country]');
      const province = root.querySelector('[data-by-shipping-province]');
      const zip = root.querySelector('[data-by-shipping-zip]');
      const params = new URLSearchParams();
      params.set('shipping_address[country]', country ? country.value : '');
      params.set('shipping_address[province]', province ? province.value : '');
      params.set('shipping_address[zip]', zip ? zip.value.trim() : '');

      const base = root.dataset.rootUrl || '/';
      const response = await fetch(base + 'cart/shipping_rates.json?' + params.toString(), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      const payload = await response.json();

      if (!response.ok || !payload || !Array.isArray(payload.shipping_rates)) {
        const messages = [];
        if (payload && typeof payload === 'object') {
          Object.values(payload).forEach((value) => {
            if (Array.isArray(value)) messages.push.apply(messages, value);
            else if (typeof value === 'string') messages.push(value);
          });
        }
        throw new Error(messages.join(' ') || root.dataset.unavailableMessage || 'Unable to calculate shipping.');
      }

      showRates(root, payload.shipping_rates);
    } catch (error) {
      setResult(root, (error && error.message) || root.dataset.unavailableMessage || 'Unable to calculate shipping.', true);
    } finally {
      setBusy(root, false);
    }
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-by-shipping-open]');
    if (openButton) {
      event.preventDefault();
      const root = getRoot(openButton);
      if (root) openDialog(root);
      return;
    }

    const closeButton = event.target.closest('[data-by-shipping-close]');
    if (closeButton) {
      event.preventDefault();
      closeDialog(getRoot(closeButton));
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-by-shipping-form]');
    if (!form) return;
    event.preventDefault();
    const root = getRoot(form);
    if (root) calculateRates(root);
  });
})();
